import React from "react"
import Stub from "../Stub"

const ReportesEntregabilidad = () => (
  <Stub
    title="Reportes de entregabilidad"
    icon="mdi-chart-line-variant"
    descripcion="Análisis profundo de bounces, hard/soft, listas de supresión y salud de la base"
    alcance={[
      "Cards y donut con resumen de bounces por origen (pre-validación, SES webhook) y por tipo (HardBounce, SoftBounce, Permanent, Transient)",
      "Tabla de destinatarios problemáticos rankeados por número de fallos",
      "Filtros por origen, bounce_type y recipient específico",
      "Acciones: marcar email como suprimido manualmente, limpiar de la base, exportar lista",
      "Comparativos histórico vs período actual",
      "Recomendaciones automáticas de limpieza (umbral configurable)",
    ]}
    endpoints={[
      { method: "GET", path: "/a7/bounces/summary?nitemisor=X", desc: "Cards y gráficos agregados" },
      { method: "GET", path: "/a7/bounces?nitemisor=X&limit=…", desc: "Listado detallado con filtros" },
      { method: "GET", path: "/a7/inbox/{cufe}/full", desc: "Drill-down al envío específico" },
    ]}
  />
)

export default ReportesEntregabilidad
